import clsx from 'clsx';
import React, { ReactNode } from 'react';

import { cn } from '@/src/util/ui';

type EmailThreadViewerLayoutProps = {
  children: ReactNode;
  className?: string;
};

const EmailThreadViewerLayout = ({ className, children }: EmailThreadViewerLayoutProps) => {
  return (
    <div
      className={cn(
        'tw-relative',
        'tw-flex tw-self-start tw-grow',
        'tw-min-h-[calc(100vh-245px)]',
        className
      )}
    >
      {children}
    </div>
  );
};

export default EmailThreadViewerLayout;
